import { useMutation, useQueryClient } from "@tanstack/react-query";

import { GINO_QUERY_KEYS } from "../queryKeys";
import { sendMessage, AddMessageRequest } from "../services/chat";

export const useSendMessage = (chatId?: number | null) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: AddMessageRequest) => {
      if (!chatId) return Promise.resolve(undefined);
      return sendMessage(chatId, params);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: GINO_QUERY_KEYS.CHAT_MESSAGES(String(chatId!)) });
      queryClient.invalidateQueries({ queryKey: GINO_QUERY_KEYS.CHAT_LIST });
    },
  });
};
